export const styleList = (state = [], action) => {
  if (action.type === 'FETCH_STYLES') {
    return action.payload;
  }

  if (action.type === 'CLEAR_STYLES') {
    return [];
  }

  return state;
};

export const style = (state = {}, action) => {
  if (action.type === 'FETCH_STYLE') {
    return action.payload;
  }

  if (action.type === 'CLEAR_STYLE') {
    return {};
  }

  return state;
};

export const stylesForJobchart = (
  state = {
    styleIndexes: {},
    styleNames: [],
    descriptions: {},
  },
  action
) => {
  if (action.type === 'FETCH_STYLES_FOR_JOBCHART') {
    return action.payload;
  }

  if (action.type === 'CLEAR_STYLES_FOR_JOBCHART') {
    return {
      styleIndexes: {},
      styleNames: [],
      descriptions: {},
    };
  }

  return state;
};

export const jobchartStylesForRpo = (
  state = {
    quantities: {},
    data: {
      products: [],
      styles: {},
    },
  },
  action
) => {
  if (action.type === 'FETCH_JOBCHART_STYLES_FOR_RPO') {
    return action.payload;
  }

  if (action.type === 'CLEAR_JOBCHART_STYLES_FOR_RPO') {
    return {
      quantities: {},
      data: {
        products: [],
        styles: {},
      },
    };
  }

  return state;
};
